import { createDayjsDate } from '@/utils/dayjs'
import { NORMAL_CUSTOMER_TYPE_VALUE, PaymentType } from '@/utils/defaultValue'

export const isInRenewOrderDate = (
  { packagePlan, packageExpiredAt },
  { unit, value }
) => {
  if (!packageExpiredAt) {
    return false
  }

  const packagePlanNotFree = packagePlan !== 'free'
  const canRenewPackage = createDayjsDate(packageExpiredAt).diff(createDayjsDate(), unit, true)
    <= value
  return packagePlanNotFree && canRenewPackage
}

export const isInRenewPremiumIdDate = (
  { premiumIdExpiredAt },
  { unit, value }
) => {
  if (!premiumIdExpiredAt) {
    return false
  }

  const canRenewPremiumId = createDayjsDate(premiumIdExpiredAt).diff(createDayjsDate(), unit, true)
    <= value
  return canRenewPremiumId
}

export const isBuyNewPremiumIdByNewAccount = ({ premiumId }) => premiumId === undefined

export const isInRenewOaChatDate = ({ oaChatExpiredAt }, { unit, value }) => {
  if (!oaChatExpiredAt) {
    return false
  }

  const canRenewOaChat = createDayjsDate(oaChatExpiredAt).diff(createDayjsDate(), unit, true)
    <= value
  return canRenewOaChat
}

export const isBuyNewOaChatByNewAccount = ({ oaChat }) => oaChat === undefined

export const mapOrdersFilterFee = (orders) => orders.map(({ orderItems, ...filterOrder }) => ({
  ...filterOrder,
  orderItems: orderItems.filter(({ productType }) => productType !== 'fee')
}))

// eslint-disable-next-line max-len
export const isUpdatedProfile = (Account) => Account.isProfileUpdate && !!Account.displayName && !!Account.emailQuotation

export const getProductName = (orderItem) => {
  if (orderItem.productType === 'message') {
    return `${String(
      orderItem.packagePlan
    ).toUpperCase()} : Additional Messages ${orderItem.unitPrice} Baht/Message`
  }

  return orderItem.productName
}

export function isJuristicCustomer(order) {
  return order.customerTypeId !== NORMAL_CUSTOMER_TYPE_VALUE
}

export function isHasPaymentAttachment(order) {
  return order.payments?.some(
    (payment) => payment.type === PaymentType.Attachment
  )
}
